import type { ComponentProps } from 'react';
import React from 'react';
import { SingleComboBox } from '@itandi/itandi-bb-ui/SingleComboBox';
import { useFormContext } from 'react-hook-form';
import type { DealSearchCondition } from '~/models/Deal';
import { useEnabledStaffs } from '~/hooks/useStaffs';
import type { Staff } from '~/models/Staff';

type Props = {
  dealSearchCondition: DealSearchCondition;
};

export const StaffCombobox: React.FC<Props> = ({
  dealSearchCondition
}: Props) => {
  const staffs = useEnabledStaffs().data;
  const { setValue } = useFormContext<DealSearchCondition>();
  const selectedStaff =
    staffs?.find(({ id }) => id === dealSearchCondition.staffId) || null;
  const [selectedStaffOption] = React.useState<
    ComponentProps<typeof SingleComboBox>['value'] | null
  >(
    selectedStaff
      ? {
          label: selectedStaff.name,
          value: String(selectedStaff.id)
        }
      : null
  );
  const onChangeStaff = React.useCallback(
    async (
      option: ComponentProps<typeof SingleComboBox>['value'] | null
    ): Promise<void> => {
      setValue('staffId', option ? Number(option.value) : undefined);
    },
    [setValue]
  );
  if (staffs === null) {
    return null;
  }
  return (
    <SingleComboBox
      defaultValue={selectedStaffOption || null}
      onChange={onChangeStaff}
      options={staffs.map((c: Staff) => ({
        label: c.name,
        value: String(c.id)
      }))}
      placeholder="担当者"
    />
  );
};
